import React from "react";
import { BsSearch } from "react-icons/bs";
import { FaTimes } from "react-icons/fa";

import Input from "./Input";
import { cn } from "./cn";

type Props = {
  value: string;
  onChange: (next: string) => void;
  placeholder?: string;
  /** Microcopy shown under the input (e.g. "12 results"). */
  hint?: React.ReactNode;
  className?: string;
  autoFocus?: boolean;
};

const SearchBar: React.FC<Props> = ({
  value,
  onChange,
  placeholder = "Search…",
  hint,
  className,
  autoFocus,
}) => (
  <div className={cn("flex flex-col gap-1", className)}>
    <Input
      type="text"
      value={value}
      placeholder={placeholder}
      onChange={(e) => onChange(e.target.value)}
      leadingIcon={<BsSearch className="h-3.5 w-3.5" />}
      trailingIcon={
        value ? (
          <button
            type="button"
            aria-label="Clear search"
            onClick={() => onChange("")}
            className="pointer-events-auto -mr-1 inline-flex h-6 w-6 items-center justify-center rounded-md text-gray-400 hover:bg-gray-100 hover:text-gray-700"
          >
            <FaTimes className="h-3 w-3" />
          </button>
        ) : undefined
      }
      autoFocus={autoFocus}
      className="h-10 text-[13.5px]"
    />
    {hint ? <p className="text-[11px] text-gray-500">{hint}</p> : null}
  </div>
);

export default SearchBar;
